import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { UserContext } from '../context/UserContext';
import { USER_ROLES } from '../constants';
import NotApproved from './NotApproved';

export default function RoleBasedGuard({ children, roles = [] }) {
  const { user, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  const isInValid = typeof user?.role === 'undefined' || !roles.includes(user.role);
  const isNotApproved = user?.role === USER_ROLES.LEAD_AGENT && !user?.isApproved;

  useEffect(() => {
    if (isInValid) {
      navigate('/dashboard');
    }
  }, [isInValid, navigate]);

  useEffect(() => {
    if (isMobileOrTablet) {
      if (!!user?.role) {
        logout();
      }
      navigate('/');
    }
  }, [isMobileOrTablet, user, navigate, logout]);

  if (isInValid || isMobileOrTablet) {
    return null;
  }

  if (isNotApproved) {
    return <NotApproved />;
  }

  return children;
}
